module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataImportBase', {
    attrs: {
      "title": '藥物',
      "uploadUrl": '/upload-medication-table/',
      "downloadUrl": '/export-medication-table/'
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69b83037","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/DataImport/DrugImport.vue
// module id = 1495
// module chunks = 1